import React, { useState } from "react";
import { Auth } from "aws-amplify";
import "./CmsLoginModal.css";

function cognitoErrorMessage(err) {
  switch (err.code) {
    case "NotAuthorizedException":
    case "UserNotFoundException":
      return "Invalid email or password.";
    case "UserNotConfirmedException":
      return "Account not confirmed — check your email for a verification link.";
    case "PasswordResetRequiredException":
      return "A password reset is required. Please reset your password in the Videri portal.";
    case "TooManyRequestsException":
    case "LimitExceededException":
      return "Too many attempts. Please wait a moment and try again.";
    default:
      return err.message || "Sign in failed. Please try again.";
  }
}

export default function CmsLoginModal({ onSuccess, embedded }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setLoading(true);
    setError(null);

    try {
      const user = await Auth.signIn(email.trim().toLowerCase(), password);
      onSuccess(user);
    } catch (err) {
      setError(cognitoErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const wrapperClass = embedded ? "cms-embedded" : "cms-overlay";

  return (
    <div className={wrapperClass}>
      <div className={embedded ? "cms-embedded-inner" : "cms-modal"}>
        {!embedded && (
          <div className="cms-modal-header">
            <h2>Sign In</h2>
          </div>
        )}
        <form
          onSubmit={handleLogin}
          className="cms-form"
          autoComplete="on"
        >
          <label className="cms-label">
            <span>Email</span>
            <input
              type="email"
              name="username"
              id="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@videri.com"
              autoComplete="username"
              autoFocus
              inputMode="email"
              spellCheck={false}
            />
          </label>
          <label className="cms-label">
            <span>Password</span>
            <input
              type="password"
              name="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              autoComplete="current-password"
            />
          </label>
          {error && <div className="cms-error">{error}</div>}
          <button type="submit" className="cms-submit" disabled={loading || !email || !password}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
